module.exports = __webpack_public_path__ + "static/media/image.a8a67ca4.svg";